// src/icons.ts
import { ReactComponent as Email } from './auth-inputs/email.svg';
import { ReactComponent as Lock } from './auth-inputs/lock.svg';
import { ReactComponent as Name } from './auth-inputs/name.svg';
import { ReactComponent as Phone } from './auth-inputs/phone.svg';
import { ReactComponent as DOB } from './auth-inputs/dob.svg';
import { ReactComponent as EyeOpen } from './auth-inputs/eyeopen.svg';
import { ReactComponent as EyeClose } from './auth-inputs/eyeclose.svg';
// social
import { ReactComponent as Facebook } from './social/facebook.svg';
import { ReactComponent as Google } from './social/google.svg';
import { ReactComponent as TikTok } from './social/ticktok.svg';
// publisher dashboard
import { ReactComponent as Chart } from './dashboard/Chart_light.svg';
import { ReactComponent as Gamepad } from './dashboard/Gamepad_light.svg';
import { ReactComponent as Category } from './dashboard/category.svg';
import { ReactComponent as GroupShare } from './dashboard/group_share_light.svg';
import { ReactComponent as Plus } from './dashboard/plus.svg';
import { ReactComponent as Setting } from './dashboard/Setting_line_light.svg';
import { ReactComponent as Wallet } from './dashboard/Wallet_alt_light.svg';
import { ReactComponent as Search } from './dashboard/state-layer.svg';
import { ReactComponent as Menu } from './dashboard/Menu.svg';
import { ReactComponent as Archive } from './dashboard/Arhive_light.svg';
import { ReactComponent as Delete } from './dashboard/Delete.svg';
import { ReactComponent as Edit } from './dashboard/Edit_light.svg';
import { ReactComponent as Ticket } from './dashboard/Ticket_light.svg';
import { ReactComponent as Signout } from './dashboard/Sign_out_squre_light.svg';
import { ReactComponent as Trash } from './dashboard/Trash_duotone.svg';
import { ReactComponent as Archived } from './dashboard/Arhive_fill_duotone.svg';
import { ReactComponent as HeaderMenu } from './dashboard/HeaderMenu.svg';
import { ReactComponent as HeaderManuUnSelected } from './dashboard/HeaderManuUnSelected.svg';
import { ReactComponent as HeaderManuSelected } from './dashboard/HeaderManuSelected.svg';
import { ReactComponent as Yohoo } from './dashboard/yohoo.svg';
import { ReactComponent as SettingUser } from './dashboard/SettingUser.svg';
import { ReactComponent as SettingDOB } from './dashboard/SettingDOB.svg';
import { ReactComponent as SettingLock } from './dashboard/SettingLock.svg';
import { ReactComponent as SettingMail } from './dashboard/SettingMail.svg';
import { ReactComponent as SettingPhone } from './dashboard/SettingPhone.svg';
import { ReactComponent as SettingEdit } from './dashboard/SettingEdit.svg';
import { ReactComponent as AdminUser } from './dashboard/Group_light.svg';
import { ReactComponent as Hold } from './dashboard/Stop_light.svg';
import { ReactComponent as Sponsored } from './dashboard/Sponsored.svg';
import { ReactComponent as PreviewUser } from './dashboard/User_fill.svg';
import { ReactComponent as PreviewEmail } from './dashboard/Message_fill.svg';
import { ReactComponent as PreviewDOB } from './dashboard/Date_range_fill.svg';
import { ReactComponent as PreviewPhone } from './dashboard/Phone_fill.svg';
import { ReactComponent as Approve } from './dashboard/Done_ring_round_light.svg';
import { ReactComponent as Reject} from './dashboard/Dell_light.svg';
import { ReactComponent as Preview} from './dashboard/View_light.svg';
import { ReactComponent as Rejected} from './dashboard/close_ring_duotone.svg';
import { ReactComponent as Approved} from './dashboard/Done_ring_round_duotone_line.svg';
import { ReactComponent as Publish} from './dashboard/Play_light.svg';
import { ReactComponent as Remove} from './dashboard/Trash_light.svg';
import { ReactComponent as Republish} from './dashboard/republish.svg';
import { ReactComponent as HoldB} from './dashboard/hold.svg';
import { ReactComponent as ChildAltLight} from './dashboard/Chield_alt_light.svg';

// extra
import { ReactComponent as ChivronUp} from './extra/chivronUp.svg';



export const Icons = {
  Email,
  Lock,
  Name,
  Phone,
  DOB,
  EyeOpen,
  EyeClose,
  Facebook,
  Google,
  TikTok,
  Chart,
  Gamepad,
  Category,
  GroupShare,
  Plus,
  Setting,
  Wallet,
  Search,
  Menu,
  Archive,
  Delete,
  Edit,
  Ticket,
  Signout,
  Trash,
  Archived,
  HeaderMenu,
  HeaderManuUnSelected,
  HeaderManuSelected,
  Yohoo,
  SettingUser,
  SettingDOB,
  SettingLock,
  SettingMail,
  SettingPhone,
  SettingEdit,
  AdminUser,
  Hold,
  Sponsored,
  PreviewUser,
  PreviewEmail,
  PreviewPhone,
  PreviewDOB,
  Approve,
  Reject,
  Preview,
  Rejected,
  Approved,
  Publish,
  Remove,
  Republish,
  HoldB,
  ChivronUp,
  ChildAltLight,
};


export type SVGIcon = React.FC<React.SVGProps<SVGSVGElement>>;
